import { useState, useEffect, useCallback, useRef } from 'react';
import styles from './TaxasEntrega.module.css';
import SideBarGestaoAdmin from '../components/SideBarGestaoAdmin';
import MobileMenu from '../../../shared/components/MobileMenu';
import HeaderAdmin from '../components/HeaderAdmin';
import { MdDeliveryDining, MdAdd, MdDelete, MdEdit, MdUploadFile, MdCheck, MdClose, MdLocationCity, MdAltRoute } from 'react-icons/md';
import TaxaPorKm from '../components/TaxaPorKm';
import kmStyles from '../components/TaxaPorKm.module.css';

const API_URL = process.env.REACT_APP_API_URL;

function cabecalhosAutenticados() {
  const token = localStorage.getItem('token');
  return {
    'Content-Type': 'application/json',
    ...(token ? { Authorization: `Bearer ${token}` } : {})
  };
}

function TaxasEntrega() {
  const estabelecimentoId = localStorage.getItem('estabelecimento_id');

  const [taxas, setTaxas] = useState([]);
  const [taxaPadrao, setTaxaPadrao] = useState(null);
  const [carregando, setCarregando] = useState(true);

  const [novoBairro, setNovoBairro] = useState('');
  const [novaCidade, setNovaCidade] = useState('');
  const [novoValor, setNovoValor] = useState('');
  const [salvandoNovo, setSalvandoNovo] = useState(false);

  const [idEmEdicao, setIdEmEdicao] = useState(null);
  const [edicaoBairro, setEdicaoBairro] = useState('');
  const [edicaoCidade, setEdicaoCidade] = useState('');
  const [edicaoValor, setEdicaoValor] = useState('');

  const [valorPadraoInput, setValorPadraoInput] = useState('');
  const [salvandoPadrao, setSalvandoPadrao] = useState(false);

  const [importando, setImportando] = useState(false);
  const inputArquivoRef = useRef(null);

  // Como o bot cobra a entrega: 'bairro' (lista abaixo) ou 'km' (faixas de distância).
  // `aba` é só o que está sendo editado; `dadosKm.modo` é o que o bot USA de verdade.
  const [dadosKm, setDadosKm] = useState(null);
  const [aba, setAba] = useState('bairro');
  const [trocandoModo, setTrocandoModo] = useState(false);

  useEffect(() => {
    if (!estabelecimentoId) return;
    fetch(`${API_URL}/whatsapp/taxas-entrega/km?id_estabelecimento=${estabelecimentoId}`, { headers: cabecalhosAutenticados() })
      .then((res) => (res.ok ? res.json() : null))
      .then((dados) => {
        if (!dados) return;
        setDadosKm(dados);
        setAba(dados.modo);
      })
      .catch(() => {});
  }, [estabelecimentoId]);

  const usarModo = async (modo) => {
    setTrocandoModo(true);
    try {
      const res = await fetch(`${API_URL}/whatsapp/taxas-entrega/km/modo`, {
        method: 'PUT',
        headers: cabecalhosAutenticados(),
        body: JSON.stringify({ id_estabelecimento: estabelecimentoId, modo })
      });
      const dados = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(dados.error || 'Falha ao trocar o modo');
      setDadosKm(dados);
    } catch (error) {
      alert(error.message);
    } finally {
      setTrocandoModo(false);
    }
  };

  const buscarTaxas = useCallback(async () => {
    if (!estabelecimentoId) return;
    setCarregando(true);
    try {
      const res = await fetch(`${API_URL}/whatsapp/taxas-entrega?id_estabelecimento=${estabelecimentoId}`, {
        headers: cabecalhosAutenticados()
      });
      if (!res.ok) throw new Error('Falha ao buscar taxas de entrega');
      const data = await res.json();
      setTaxas(data.taxas || []);
      setTaxaPadrao(data.taxa_padrao);
      setValorPadraoInput(data.taxa_padrao === null ? '' : String(data.taxa_padrao));
    } catch (error) {
      console.log('Erro ao buscar taxas de entrega:', error.message);
    } finally {
      setCarregando(false);
    }
  }, [estabelecimentoId]);

  useEffect(() => { buscarTaxas(); }, [buscarTaxas]);

  const adicionarTaxa = async (e) => {
    e.preventDefault();
    if (!novoBairro.trim() || !novoValor || salvandoNovo) return;

    setSalvandoNovo(true);
    try {
      const res = await fetch(`${API_URL}/whatsapp/taxas-entrega`, {
        method: 'POST',
        headers: cabecalhosAutenticados(),
        body: JSON.stringify({ id_estabelecimento: estabelecimentoId, bairro: novoBairro, cidade: novaCidade, valor: novoValor })
      });
      if (!res.ok) {
        const erro = await res.json().catch(() => ({}));
        throw new Error(erro.error || 'Falha ao adicionar taxa');
      }
      setNovoBairro('');
      setNovaCidade('');
      setNovoValor('');
      await buscarTaxas();
    } catch (error) {
      alert('Erro ao adicionar taxa: ' + error.message);
    } finally {
      setSalvandoNovo(false);
    }
  };

  const iniciarEdicao = (taxa) => {
    setIdEmEdicao(taxa.id);
    setEdicaoBairro(taxa.bairro);
    setEdicaoCidade(taxa.cidade || '');
    setEdicaoValor(String(taxa.valor));
  };

  const cancelarEdicao = () => setIdEmEdicao(null);

  const salvarEdicao = async (id) => {
    try {
      const res = await fetch(`${API_URL}/whatsapp/taxas-entrega/${id}`, {
        method: 'PUT',
        headers: cabecalhosAutenticados(),
        body: JSON.stringify({ id_estabelecimento: estabelecimentoId, bairro: edicaoBairro, cidade: edicaoCidade, valor: edicaoValor })
      });
      if (!res.ok) {
        const erro = await res.json().catch(() => ({}));
        throw new Error(erro.error || 'Falha ao salvar');
      }
      setIdEmEdicao(null);
      await buscarTaxas();
    } catch (error) {
      alert('Erro ao salvar taxa: ' + error.message);
    }
  };

  const removerTaxa = async (id, bairro) => {
    if (!window.confirm(`Remover a taxa de entrega do bairro "${bairro}"?`)) return;
    try {
      const res = await fetch(`${API_URL}/whatsapp/taxas-entrega/${id}?id_estabelecimento=${estabelecimentoId}`, {
        method: 'DELETE',
        headers: cabecalhosAutenticados()
      });
      if (!res.ok) throw new Error('Falha ao remover');
      await buscarTaxas();
    } catch (error) {
      alert('Erro ao remover taxa: ' + error.message);
    }
  };

  const salvarTaxaPadrao = async () => {
    setSalvandoPadrao(true);
    try {
      const res = await fetch(`${API_URL}/whatsapp/taxas-entrega/padrao`, {
        method: 'PUT',
        headers: cabecalhosAutenticados(),
        body: JSON.stringify({ id_estabelecimento: estabelecimentoId, valor: valorPadraoInput })
      });
      if (!res.ok) {
        const erro = await res.json().catch(() => ({}));
        throw new Error(erro.error || 'Falha ao salvar taxa padrão');
      }
      const dados = await res.json();
      setTaxaPadrao(dados.taxa_padrao);
      alert('Taxa padrão salva!');
    } catch (error) {
      alert('Erro ao salvar taxa padrão: ' + error.message);
    } finally {
      setSalvandoPadrao(false);
    }
  };

  const abrirSeletorDePlanilha = () => {
    const confirmou = window.confirm(
      'Importar taxas de entrega\n\n' +
      'A planilha (.xlsx, .xls ou .csv) precisa ter estas colunas:\n' +
      '  • bairro\n' +
      '  • cidade (opcional)\n' +
      '  • valor\n\n' +
      'Bairro que já existir (mesmo bairro + cidade) tem o valor atualizado; bairro novo é criado.\n\n' +
      'Clique OK pra escolher o arquivo.'
    );
    if (!confirmou) return;
    inputArquivoRef.current?.click();
  };

  const importarPlanilha = async (evento) => {
    const arquivo = evento.target.files?.[0];
    evento.target.value = '';
    if (!arquivo || importando) return;

    setImportando(true);
    try {
      const formData = new FormData();
      formData.append('id_estabelecimento', estabelecimentoId);
      formData.append('arquivo', arquivo);

      const token = localStorage.getItem('token');
      const res = await fetch(`${API_URL}/whatsapp/taxas-entrega/importar`, {
        method: 'POST',
        headers: token ? { Authorization: `Bearer ${token}` } : {},
        body: formData
      });

      const dados = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(dados.error || 'Falha ao importar planilha');

      alert(`Importação concluída!\nNovos: ${dados.importadas}\nAtualizados: ${dados.atualizadas}\nIgnorados (linha inválida): ${dados.ignoradas}`);
      await buscarTaxas();
    } catch (error) {
      alert('Erro ao importar planilha: ' + error.message);
    } finally {
      setImportando(false);
    }
  };

  return (
    <div className={styles.wrapperDashboard}>
      <MobileMenu />
      <SideBarGestaoAdmin />
      <div className={styles.containerDashboard}>
        <HeaderAdmin />
        <div className={styles.contentDashboard}>
          <div className={styles.cabecalhoPagina}>
            <span className={styles.iconePagina}><MdDeliveryDining /></span>
            <div className={styles.cabecalhoPaginaTextos}>
              <h2 className={styles.tituloPagina}>Taxa de Entrega</h2>
              <p className={styles.subtituloPagina}>Escolha como o bot do WhatsApp calcula e avisa a taxa de entrega.</p>
            </div>
            {aba === 'bairro' && (
              <button className={styles.btnImportar} onClick={abrirSeletorDePlanilha} disabled={importando}>
                <MdUploadFile /> <span>{importando ? 'Importando...' : 'Importar planilha'}</span>
              </button>
            )}
            <input ref={inputArquivoRef} type="file" accept=".xlsx,.xls,.csv" hidden onChange={importarPlanilha} />
          </div>

          <div className={kmStyles.seletor}>
            {[
              { id: 'bairro', titulo: 'Por bairro', texto: 'O cliente diz o bairro e o bot cobra o valor da sua lista.', icone: <MdLocationCity /> },
              { id: 'km', titulo: 'Por distância (km)', texto: 'O bot mede a distância pela rua (Google Maps) e cobra pela faixa de km.', icone: <MdAltRoute /> }
            ].map((opcao) => {
              const emUso = dadosKm?.modo === opcao.id;
              return (
                <div
                  key={opcao.id}
                  role="button"
                  tabIndex={0}
                  className={`${kmStyles.opcao} ${aba === opcao.id ? kmStyles.opcaoAtiva : ''}`}
                  onClick={() => setAba(opcao.id)}
                  onKeyDown={(e) => { if (e.key === 'Enter') setAba(opcao.id); }}
                >
                  <span className={kmStyles.opcaoTitulo}>{opcao.icone} {opcao.titulo} {emUso && <span className={kmStyles.emUso}>em uso</span>}</span>
                  <span className={kmStyles.opcaoTexto}>{opcao.texto}</span>
                  {!emUso && aba === opcao.id && dadosKm && (
                    <button className={kmStyles.btnUsar} disabled={trocandoModo} onClick={(e) => { e.stopPropagation(); usarModo(opcao.id); }}>
                      {trocandoModo ? 'Aguarde...' : 'Usar este modo'}
                    </button>
                  )}
                </div>
              );
            })}
          </div>

          {aba === 'km' && dadosKm && (
            <TaxaPorKm estabelecimentoId={estabelecimentoId} dados={dadosKm} onAtualizar={setDadosKm} />
          )}

          {aba === 'bairro' && (<>
          <div className={styles.painelPadrao}>
            <div>
              <strong className={styles.painelPadraoTitulo}>Taxa padrão (bairro fora da lista)</strong>
              <p className={styles.painelPadraoTexto}>
                Se o cliente digitar um bairro que não está na lista abaixo, o bot usa esse valor (avisando que é uma estimativa). Deixe em branco pra sempre chamar um atendente nesse caso.
              </p>
            </div>
            <div className={styles.painelPadraoAcao}>
              <span className={styles.prefixoReais}>R$</span>
              <input
                className={styles.inputValorPadrao}
                type="number"
                min="0"
                step="0.01"
                placeholder="sem taxa padrão"
                value={valorPadraoInput}
                onChange={(e) => setValorPadraoInput(e.target.value)}
              />
              <button className={styles.btnSalvarPadrao} onClick={salvarTaxaPadrao} disabled={salvandoPadrao}>
                {salvandoPadrao ? 'Salvando...' : 'Salvar'}
              </button>
            </div>
          </div>

          <form className={styles.formNovaTaxa} onSubmit={adicionarTaxa}>
            <strong className={styles.formNovaTaxaTitulo}>Adicionar bairro</strong>
            <div className={styles.formNovaTaxaGrade}>
              <label className={styles.campo}>
                <span className={styles.campoRotulo}>Bairro</span>
                <input
                  className={styles.inputTaxa}
                  placeholder="Ex: Centro"
                  value={novoBairro}
                  onChange={(e) => setNovoBairro(e.target.value)}
                />
              </label>
              <label className={styles.campo}>
                <span className={styles.campoRotulo}>Cidade (opcional)</span>
                <input
                  className={styles.inputTaxa}
                  placeholder="Ex: São Paulo"
                  value={novaCidade}
                  onChange={(e) => setNovaCidade(e.target.value)}
                />
              </label>
              <label className={styles.campo}>
                <span className={styles.campoRotulo}>Valor da taxa</span>
                <div className={styles.inputComPrefixo}>
                  <span>R$</span>
                  <input
                    className={styles.inputTaxaValor}
                    type="number"
                    min="0"
                    step="0.01"
                    placeholder="0,00"
                    value={novoValor}
                    onChange={(e) => setNovoValor(e.target.value)}
                  />
                </div>
              </label>
              <button className={styles.btnAdicionarTaxa} type="submit" disabled={salvandoNovo}>
                <MdAdd /> <span>Adicionar</span>
              </button>
            </div>
          </form>

          <div className={styles.tabelaWrapper}>
            {carregando ? (
              <p className={styles.mensagemVazia}>Carregando...</p>
            ) : taxas.length === 0 ? (
              <p className={styles.mensagemVazia}>Nenhum bairro cadastrado ainda — adicione um acima ou importe uma planilha.</p>
            ) : (
              <table className={styles.tabela}>
                <thead>
                  <tr>
                    <th>Bairro</th>
                    <th>Cidade</th>
                    <th>Valor</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {taxas.map(taxa => (
                    <tr key={taxa.id}>
                      {idEmEdicao === taxa.id ? (
                        <>
                          <td data-label="Bairro"><input className={styles.inputLinha} value={edicaoBairro} onChange={(e) => setEdicaoBairro(e.target.value)} /></td>
                          <td data-label="Cidade"><input className={styles.inputLinha} value={edicaoCidade} onChange={(e) => setEdicaoCidade(e.target.value)} /></td>
                          <td data-label="Valor">
                            <div className={styles.inputComPrefixo}>
                              <span>R$</span>
                              <input className={styles.inputLinhaValor} type="number" min="0" step="0.01" value={edicaoValor} onChange={(e) => setEdicaoValor(e.target.value)} />
                            </div>
                          </td>
                          <td className={styles.colunaAcoes}>
                            <button className={styles.btnIcone} onClick={() => salvarEdicao(taxa.id)} title="Salvar"><MdCheck /></button>
                            <button className={styles.btnIcone} onClick={cancelarEdicao} title="Cancelar"><MdClose /></button>
                          </td>
                        </>
                      ) : (
                        <>
                          <td data-label="Bairro">{taxa.bairro}</td>
                          <td data-label="Cidade" className={styles.colunaMuted}>{taxa.cidade || '—'}</td>
                          <td data-label="Valor">R$ {Number(taxa.valor).toFixed(2)}</td>
                          <td className={styles.colunaAcoes}>
                            <button className={styles.btnIcone} onClick={() => iniciarEdicao(taxa)} title="Editar"><MdEdit /></button>
                            <button className={styles.btnIcone} onClick={() => removerTaxa(taxa.id, taxa.bairro)} title="Remover"><MdDelete /></button>
                          </td>
                        </>
                      )}
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
          </>)}
        </div>
      </div>
    </div>
  );
}

export default TaxasEntrega;
